<template>
  <div class="dt-flex">
    <InfoText
      icon="$localization-globe-filled"
      iconColor="primary"
      :label="lc.label"
    >
      <div class="dt-flex flex-row">
        <span
          class="text-paragraph-2 font-weight-bold pr-2"
          v-text="languagesText"
        />
        <!-- FIXME: change mustache syntax using text prop -->
        <Link color="primary" to="#">{{ actionText }}</Link>
      </div>
    </InfoText>
    <div class="mt-2" v-if="shouldRenderTags">
      <Tag
        class="mr-2"
        v-for="language in renderedLanguages"
        :key="language"
        :text="language"
        small
      />
      <Tag :text="hiddenLanguagesText" v-if="shouldShowMoreLanguages" small />
    </div>
  </div>
</template>
<script>
import { InfoText, Tag, Link } from '@locaweb/design-system-vue'

const RENDERED_TAGS = 3

export default {
  name: 'MultiLanguage',
  components: {
    InfoText,
    Tag,
    Link
  },
  inheritAttrs: false,
  props: {
    languages: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    lc () {
      return this.$lc('site.components.siteCard.multiLanguage')
    },
    languageCount () {
      return this.languages?.length ?? 0
    },
    languagesText () {
      return this.lc.installedMessage.compile(this.languageCount, { count: this.languageCount })
    },
    actionText () {
      return this.lc.addLanguage
    },
    hiddenLanguages () {
      return Math.max(0, this.languageCount - RENDERED_TAGS)
    },
    renderedLanguages () {
      return this.languages?.slice(0, RENDERED_TAGS)
    },
    shouldRenderTags () {
      return this.languageCount > 0
    },
    shouldShowMoreLanguages () {
      return this.hiddenLanguages > 0
    },
    hiddenLanguagesText () {
      return `+${this.hiddenLanguages}`
    }
  }
}
</script>
